import { render, staticRenderFns } from "./RestaurantsForm.vue?vue&type=template&id=e5ae9b54"
import script from "./RestaurantsForm.vue?vue&type=script&lang=js"
export * from "./RestaurantsForm.vue?vue&type=script&lang=js"
import style0 from "./RestaurantsForm.vue?vue&type=style&index=0&id=e5ae9b54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports